import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, } from '@material-ui/core';
import MTabsButton from '../../view/MTabsButton';
import MSectionHeader from '../../view/MSectionHeader';
import Apis from '../../../network/Apis';

class MovieIntelligence extends React.Component {

    constructor(props) {
        super(props);
        this.state = { value: 0, intelligenceData: null };
        console.log('MovieIntelligence', props);
    }

    componentDidMount() {
        this.getIntelligence();
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getIntelligence = async () => {
        let result = await Apis.encryptionGetIntelligence(this.props.data.match_type, this.props.data.match_id);
        console.log('getIntelligence', result);
        if (result.code == 200) {
            this.setState({ intelligenceData: result.data });
        }
    }

    _handleChange = (val) => {
        this.setState({ value: val })
    }

    getGoodIntelligence = (val) => {
        if (!this.state.intelligenceData || !this.state.intelligenceData.good) {
            return ['暂无数据'];
        }
        let result = '';
        if (val == 0) {
            result = this.state.intelligenceData.good.home;
        } else {
            result = this.state.intelligenceData.good.away;
        }
        if (result == '' || result == null || result == undefined || result.length == 0) {
            return ['暂无数据'];
        }
        return result;
    }

    getBadIntelligence = (val) => {
        if (!this.state.intelligenceData || !this.state.intelligenceData.bad) {
            return ['暂无数据'];
        }
        let result = '';
        if (val == 0) {
            result = this.state.intelligenceData.bad.home;
        } else {
            result = this.state.intelligenceData.bad.away;
        }
        if (result == '' || result == null || result == undefined || result.length == 0) {
            return ['暂无数据'];
        }
        return result;
    }

    getNeutralIntelligence = () => {
        if (!this.state.intelligenceData
            || !this.state.intelligenceData.neutral
            || this.state.intelligenceData.neutral == ''
            || this.state.intelligenceData.neutral.length == 0) {
            return ['暂无数据'];
        }
        return this.state.intelligenceData.neutral;
    }


    render() {
        const { classes } = this.props;
        const { value } = this.state;

        let goodData = this.getGoodIntelligence(value);
        let badData = this.getBadIntelligence(value);
        let intelligenceData = this.getNeutralIntelligence(value);

        return (
            <Grid container direction='column' alignItems='center' justify='center' className={classes.root}>
                <Grid container direction='column' alignItems='center' justify='center' style={{ marginTop: 16, marginBottom: 8 }}>
                    <MTabsButton data={[this.props.data ? this.props.data.home_name : '', this.props.data ? this.props.data.away_name : '']} onChange={(val) => this._handleChange(val)} />
                </Grid>
                <MSectionHeader title='有利情报' color='#368CF4' lineColor='#368CF4' />
                <Grid container justify='flex-start' direction='column' style={{ flex: 1, paddingLeft: 8, paddingRight: 8, width: '100%' }}>
                    {
                        goodData.map((item, i) => (
                            <Typography key={i} style={{ fontSize: 12, color: '#878787', marginBottom: 8, textAlign: 'left' }}>{item[1]}</Typography>
                        ))
                    }
                </Grid>
                <MSectionHeader title='不利情报' color='#FC2E34' lineColor='#FC2E34' />
                <Grid container justify='flex-start' direction='column' style={{ flex: 1, paddingLeft: 8, paddingRight: 8, width: '100%' }}>
                    {
                        badData.map((item, i) => (
                            <Typography key={i} style={{ fontSize: 12, color: '#878787', marginBottom: 8, textAlign: 'left' }} >{item[1]}</Typography>
                        ))
                    }
                </Grid>
                <MSectionHeader title='中立情报' color='#34CF16' lineColor='#34CF16' />
                <Grid container justify='flex-start' direction='column' style={{ flex: 1, paddingLeft: 8, paddingRight: 8, width: '100%' }}>
                    {
                        intelligenceData.map((item, i) => (
                            <Typography key={i} style={{ fontSize: 12, color: '#878787', marginBottom: 8, textAlign: 'left' }} >{item[1]}</Typography>
                        ))
                    }
                </Grid>
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: '#FFF'
    },

}))(MovieIntelligence));